<template>
    <SazkaSpinLoader center v-if="isLoading" />
    <RouterView v-else />
    <SnackbarsContainer />
    <SazkaChat />
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import { RouterView, useRouter } from "vue-router";
import { Loader } from "@/shared/components/master-page/loader";
import SazkaSpinLoader from "./shared/components/atoms/SazkaSpinLoader.vue";
import SnackbarsContainer from "@/shared/components/molecules/SnackbarsContainer.vue";
import SazkaChat from "./shared/components/molecules/SazkaChat.vue";

const isLoading = ref(true);
const isFirstLoad = ref(true);

onMounted(async () => {
    const router = useRouter();

    router.beforeEach((to, from, next) => {
        if (isFirstLoad.value) {
            isLoading.value = true;
        }
        next();
    });

    router.afterEach(() => {
        if (isFirstLoad.value) {
            isLoading.value = false;
            isFirstLoad.value = false;
        }
    });
    Loader.hide();

    // Temp hack to show the correct page in edit mode
    // Kentico is using preview URLs, so router doesnt catch up
    if (environment.isEditMode) {
        router.push("/");
    }
});
</script>
